import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cs from 'classnames';

import styles from './StateLabel.module.scss';

const open = {
  text: 'claim.open',
  color: 'green',
};

const closed = {
  text: 'claim.closed',
  color: 'blue',
};

const StateLabel = ({ invoice }) => {
  const { t } = useTranslation();

  const stateLabel = invoice.isStateOpen ? open : closed;

  return (
    <span className={cs(styles.stateLabel, styles[stateLabel.color])}>
      {t(stateLabel.text)}
    </span>
  );
};

StateLabel.propTypes = {
  invoice: PropTypes.shape({
    isStateOpen: PropTypes.bool,
  }).isRequired,
};

export default StateLabel;
